function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
export function systemConfigCheck(pram) {
  var data = {
    name: pram.name
  };
  return request({
    url: '/admin/system/config/check',
    method: 'GET',
    params: data
  });
}
export function systemConfigInfo(pram) {
  var data = {
    formId: pram.id
  };
  return request({
    url: '/admin/system/config/info',
    method: 'GET',
    params: data
  });
}
export function systemConfigSave(pram) {
  return request({
    url: '/admin/system/config/save/form',
    method: 'POST',
    data: pram
  });
}

/**
 * 文件上传
 * @param data
 */
export function fileFileApi(data, params) {
  return request({
    url: '/publicly/upload/file',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片上传
 * @param data
 */
export function fileImageApi(data, params) {
  return request({
    url: '/publicly/upload/image',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片列表
 * @param data
 */
export function fileListApi(params) {
  return request({
    url: '/admin/merchant/attachment/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      keywords: encodeURI(params.keywords)
    })
  });
}

/**
 * 编辑附件名称
 * @param data
 */
export function attachmentNameUpdateApi(data) {
  return request({
    url: '/admin/merchant/attachment/name/update',
    method: 'post',
    data: data
  });
}

/**
 * 图片列表 删除图片
 * @param data
 */
export function fileDeleteApi(id) {
  return request({
    url: "/admin/merchant/attachment/delete",
    method: 'post',
    data: {
      ids: id
    }
  });
}

/**
 * 图片列表 移動分類
 * @param data
 */
export function attachmentMoveApi(data) {
  return request({
    url: "/admin/merchant/attachment/move",
    method: 'post',
    data: data
  });
}

/**
 *  商家小票打印配置列表
 * @param pram
 * @returns {*}
 */
export function merchantPrintList(pram) {
  return request({
    url: '/admin/merchant/print/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 商家小票打印配置删除
 * @param id
 * @returns {*}
 */
export function merchantPrintDelete(id) {
  return request({
    url: '/admin/merchant/print/delete/' + id,
    method: 'GET'
  });
}

/**
 * 商家小票打印配置详情
 * @param pram
 * @returns {*}
 */
export function merchantPrintInfo(pram) {
  var data = {
    key: pram.key
  };
  return request({
    url: '/admin/merchant/print/info/{id}',
    method: 'GET',
    params: data
  });
}

/**
 * 商家小票打印配置新增
 * @param data
 * @returns {*}
 */
export function merchantPrintSave(data) {
  return request({
    url: "/admin/merchant/print/save",
    method: 'post',
    data: data
  });
}

/**
 * 商家小票打印配置更新状态
 * @param data
 * @returns {*}
 */
export function merchantPrintStatus(data) {
  return request({
    url: "/admin/merchant/print/status",
    method: 'post',
    data: data
  });
}

/**
 * 商家小票打印配置编辑
 * @param data
 * @returns {*}
 */
export function merchantPrintEdit(data) {
  return request({
    url: "/admin/merchant/print/update",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单编辑
 * @param data
 * @returns {*}
 */
export function merchantElectrSheetEdit(data) {
  return request({
    url: "/admin/merchant/elect/update",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单新增
 * @param data
 * @returns {*}
 */
export function merchantElectrSheetAdd(data) {
  return request({
    url: "/admin/merchant/elect/save",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单详情
 * @returns {*}
 */
export function merchantElectrSheetInfo() {
  return request({
    url: "/admin/merchant/elect/info",
    method: 'get'
  });
}

/**
 * 商家电子面单删除
 * @param id
 * @returns {*}
 */
export function merchantElectrSheetDelete(id) {
  return request({
    url: "/admin/merchant/elect/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 店铺地址分页列表
 * @param data
 * @returns {*}
 */
export function merchantAddressListApi() {
  return request({
    url: "/admin/merchant/address/list",
    method: 'get'
  });
}

/**
 * 删除店铺地址
 * @param data
 * @returns {*}
 */
export function merchantAddressDeleteApi(id) {
  return request({
    url: "/admin/merchant/address/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 新增店铺地址
 * @param data
 * @returns {*}
 */
export function merchantAddressSaveApi(data) {
  return request({
    url: "/admin/merchant/address/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改店铺地址
 * @param data
 * @returns {*}
 */
export function merchantAddressUpdateApi(data) {
  return request({
    url: "/admin/merchant/address/update",
    method: 'post',
    data: data
  });
}

/**
 * 设置商户默认地址
 * @param data
 * @returns {*}
 */
export function merchantAddressSetDefaultApi(id) {
  return request({
    url: "/admin/merchant/address/set/default/".concat(id),
    method: 'post'
  });
}

/**
 * 设置店铺地址开启状态
 * @param data
 * @returns {*}
 */
export function merchantAddressUpdateShowApi(id) {
  return request({
    url: "/admin/merchant/address/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 获取平台当前的素材地址
 */
export function mediadomainApi() {
  return request({
    url: '/publicly/config/get/admin/mediadomain',
    method: 'get'
  });
}

/**
 * 获取打印内容配置
 */
export function getPrintContentApi(id) {
  return request({
    url: "/admin/merchant/print/get/content/".concat(id),
    method: 'get'
  });
}

/**
 * 保存打印内容配置
 */
export function savePrintContentApi(data, id) {
  return request({
    url: "/admin/merchant/print/save/content/".concat(id),
    method: 'post',
    data: data
  });
}